import { useQuery } from "@tanstack/react-query";
import { wrapperResult } from "@api/osp";
import { QUERY_KEYS } from "@config";
import { useOspApiClientProvider } from "@hooks";
const PAGE_SIZE = 100;

export interface TokenTopProps {
  enabled?: boolean;
  pageSize?: number;
  staleTime?: number;
}
export const useTokenTopDashboard = ({
  enabled = true,
  pageSize = PAGE_SIZE,
  staleTime = 30 * 1000,
}: TokenTopProps) => {
  const { openApi } = useOspApiClientProvider();
  const {
    data: result,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [QUERY_KEYS.TOP_PROJECT, pageSize],
    enabled: !!openApi && enabled,
    /**
     * 30s 后重新请求
     */
    staleTime,
    queryFn: async () => {
      const data = await wrapperResult(
        openApi!.tokenseek.listTopProjects({
          limit: pageSize,
          offset: 0, // API 从1开始计数
        }),
      );
      return data;
    },
  });

  return {
    data: result?.rows || [],
    total: result?.total || 0,
    loading: isFetching,
    refetch,
  };
};
